module.exports = __webpack_public_path__ + "img/n.764a08d2.jpg";